import BaseService from "./geral/BaseService";

const base = "AgendCargaGeral"

export default class AgendamentoCargaGeralService extends BaseService {
    constructor() {
        super(base);
    };

    listar(operacao, placa, cpf, cnh, status, utilizado){
        let filtros = "?";
        if (operacao) filtros = filtros.concat(`operacao=${operacao}`);
        if (placa) filtros = filtros.concat(`&placa=${placa}`);
        if (cpf) filtros = filtros.concat(`&cpf=${cpf}`);
        if (cnh) filtros = filtros.concat(`&cnh=${cnh}`);
        if (status) filtros = filtros.concat(`&status=${status}`);
        if (utilizado) filtros = filtros.concat(`&utilizado=${utilizado}`);
        filtros = filtros.replace("?&", "?");
        return super.httpGet(`/${base}/ListarCargaGeral${filtros}`)
    };

    listarOperaçoes() {
        return super.httpGet(`/${base}/ListarOperacaoCargaGeraConsulta`)
    }

    listarOperaçoesAgend(){
        return super.httpGet(`/${base}/ListarOperacaoCargaGeralAgend`)
    }

    xlsImporta(xmlDoc) {
        return super.httpPost(`/${base}/TransformarXlsEmAgendamentos`, xmlDoc)
    };

    inativar (agend) {
        return super.httpPost(`/${base}/InativarAgend`, agend);
    };

    salvar(agend){
        return super.httpPost(`/${base}/SalvarAgend`, agend);
    };

    buscarMotoristaPorCNH(cnh) {
        return super.httpGet(`/${base}/CarregarMotoristaPorCnh/${cnh}`);
    };
    
    listarAcompanhamento(operacao, placa, cpf, cnh, dataInicio, dataFim){
        let filtros = "?";
        if (operacao) filtros = filtros.concat(`operacaoId=${operacao}`);
        if (placa) filtros = filtros.concat(`&placa=${placa}`);
        if (cpf) filtros = filtros.concat(`&cpf=${cpf}`);
        if (cnh) filtros = filtros.concat(`&cnh=${cnh}`);
        if (dataInicio) filtros = filtros.concat(`&dataInicio=${dataInicio}`);
        if (dataFim) filtros = filtros.concat(`&dataFim=${dataFim}`);
        filtros = filtros.replace("?&", "?");
        return super.httpGet(`/${base}/ListarAcompanhamento${filtros}`)
    };
}


// WEBPACK FOOTER //
// ./src/services/AgendamentoCargaGeralService.js